import areaApi from '@/api/config/areaApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useSearchSubAreaId(interfaceId: Number, id?: Number) {
  return useQuery([queryKeys.areaZone, id], async () => {
    if (!interfaceId || !id) return null
    const { data } = await areaApi.getById(interfaceId, id)

    if (!data) return null

    return data
  })
}

export default useSearchSubAreaId
